import { render } from "./ChatPage.vue?vue&type=template&id=0b61c522"
import script from "./ChatPage.vue?vue&type=script&lang=js"
export * from "./ChatPage.vue?vue&type=script&lang=js"

import "./ChatPage.vue?vue&type=style&index=0&id=0b61c522&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__